import { graphql } from './graphql';

export const sortOptionsFragment = graphql(`
  fragment SortOptionsFragment on SearchPageSortOptions {
    forRent {
      options {
        label
        value
      }
    }
    forSale {
      options {
        label
        value
      }
    }
    sold {
      options {
        label
        value
      }
    }
    offMarket {
      options {
        label
        value
      }
    }
    allPropertyStatuses {
      options {
        label
        value
      }
    }
  }
`);
